import { render, staticRenderFns } from "./StatRow.vue?vue&type=template&id=81a65be2&scoped=true"
import script from "./StatRow.vue?vue&type=script&lang=js"
export * from "./StatRow.vue?vue&type=script&lang=js"
import style0 from "./StatRow.vue?vue&type=style&index=0&id=81a65be2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a65be2",
  null
  
)

export default component.exports